/**
 * Created by Won on 6/17/2016.
 */
/* @ngInject */
export default function DefinitionParameterRangeApiService($resource, __env) {
    return {
        getDefinitionParameterRanges: function (definitionIds, dA, callBack) {
            $resource(
                `${__env.intellidataApiUrl}definition-parameters/:ids/parameters/ranges`,
                {ids: definitionIds, displayArea: dA}
            ).query(callBack);
        }
    };
}
